import React from 'react'
import Text from '@components/Text'
import Button from '@components/Button'
import { BUTTON_SIZE, TEXT_ALIGN } from '@helpers/constants'

const RenderItem = (props) => {
  const {
    original,
    // thumbnail,
    description,
    onClose,
  } = props

  return (
    <div className={`px-[136px] py-8`}>
      <div
        className='px-12 pb-8 bg-lightLightGrey rounded-t-2xl max-h-full'
        onClick={(e) => e.stopPropagation()}
      >
        <div className={'flex w-full justify-end py-3'}>
          <Button
            handleClick={onClose}
            size={BUTTON_SIZE.NO_PADDING}
            icon={'Close'}
            iconRight
          >
            Stäng
          </Button>
        </div>

        <img
          className='object-contain'
          style={{ maxHeight: 'calc(100vh - 12rem)' }}
          src={original}
          alt=''
          srcSet=''
          sizes=''
          title=''
        />
      </div>

      <div
        className='bg-demoGreen px-12 p-4 rounded-b-2xl leading-6 whitespace-normal text-left'
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{maxWidth: 'fit-content'}}>
          {description}
        </div>
      </div>
    </div>
  )
}

RenderItem.displayName = 'RenderItem'

const MemoizedRenderItem = React.memo(RenderItem)

export default MemoizedRenderItem
